module.exports = __webpack_public_path__ + "img/avatar_placeholder.faa156d3.svg";